$(document).on('click', '.ajax-cart__gift-notes .ajax-cart__gift-note-label',function(){
    $(".ajax-cart__gift-note-wrapper .js-cart-note").keyup(function() {
        var selfValue = $(this).val();
        if (selfValue === '') {
            $('#checkout').attr('disabled','disabled');
        } else {
            $('#checkout').removeAttr('disabled');
        }
    });
    var self = $(this).find('#gift-note');
    var noteValue = $(this).find('.ajax-cart__gift-note-wrapper .js-cart-note').val();
    if(self.prop('checked')==true && noteValue == ''){
        $('#checkout').attr('disabled','disabled');
    }else{
        $('#checkout').removeAttr('disabled');
    }
});

